import { upgradeConstants } from "../../../constants/upgradeConstant";
import { LocalStorageService } from "../../../services";

const initialState = {};

export default function upgrade(state = initialState, action) {
  switch (action.type) {
    case upgradeConstants.USER_UPGRADE_SUCCESS:
      return {
        loading: true,
        name: action.name,
      };

    default:
      return state;
  }
}
